import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IThreatAssessmentTeam } from '../../../../../shared/models/contact';
import { ContactsService } from '../../../../../shared/services/contact.service';
import { UserDataService } from '../../../../../shared/services/auth/userData.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SpinnerComponent } from '../../../../components/spinner/spinner.component';

@Component({
  selector: 'case-closing-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent
  ],
  templateUrl: './case-closing-signature.component.html',
  styleUrl: './case-closing-signature.component.css'
})
export class CaseClosingSignatureComponent implements OnInit, OnChanges {

  @Input() caseClosingSummaryData: any;
  @Output() onSaveSection3 = new EventEmitter<any>();

  caseClosingSignatureForm: FormGroup = new FormGroup([]);
  
  currentDate = new Date();
  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  currentContact: IThreatAssessmentTeam | null = null;
  messageModal: string | null = null;

  loading: boolean = false;

  constructor(
    private contactsService: ContactsService,
    private userDataService: UserDataService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.currentContact = this.userDataService.getCurrentUser();
    
    this.initializeForm();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caseClosingSummaryData'] && this.caseClosingSummaryData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.caseClosingSignatureForm = new FormGroup({
      user_signature_name: new FormControl(this.caseClosingSummaryData?.user_signature_name || '', Validators.required),
    });
  }
  

  saveCaseClosingSignature(): void {
    if (this.caseClosingSignatureForm.valid) {
      const data = this.caseClosingSignatureForm.value;
      this.onSaveSection3.emit(data);
    }
  }

}
